// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 228) return "static/chunks/252f366e-4638cd63a8adfc17.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"298":"45e6b777","315":"ucare-panel-chunk","326":"f70991a6","571":"b637e9a5","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"298":"2d74386a7b38c26f","315":"6a9f928b7c6b1d17","326":"93b2dbdf079d212e","571":"ff6727d4ed65fc4d","663":"6a6774636ae86e0e","911":"e7c1244fb1b4e35c","923":"23999ed525f3aad2"}[chunkId] + ".js";
};